import React, { useState, useEffect } from 'react';
import styles from './SaveNewRoleModal.module.scss';
import { Modal, Box, TextField, Button, Grid } from '@mui/material';
import CustomButton from '../../../../layout/customButton/CustomButton';
import ColorSelector from '../../../roleSettingSection/colorSelector/ColorSelector';
import { saveAccessibility } from '../../../../../api/UserManagement/saveAccessibility.api';
import { closeModal, openModal } from '../../../../../redux/modals/action';
import { connect } from 'react-redux';

const style = {
	position: 'absolute',
	top: '40%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '35%',
	bgcolor: 'background.paper',
	borderRadius: '4px',
	boxShadow: 24,
};

const SaveNewRoleModal = (props) => {
	const {
		openNewRoleModal,
		setOpenNewRoleModal,
		accessibilityCheckbox,
		projectToEdit,
		userId,
		closeModal,
		openModal,
		setUserSelected,
		setNewRole,
		projectsList,
		setProjectsList,
	} = props;
	const [roleName, setRoleName] = useState('');
	const [color, setColor] = useState('');
	const [success, setSuccess] = useState(false);

	const handleCloseNewRoleModal = () => {
		setOpenNewRoleModal(false);
		setRoleName('');
		setColor('');
		setSuccess(false);

		openModal('addUserMgmt');
		setUserSelected(userId);
	};

	const handleChangeRoleName = (event) => {
		setRoleName(event.target.value);
	};

	const handleSaveRole = async () => {
		let result = await saveAccessibility(
			projectToEdit,
			roleName,
			accessibilityCheckbox,
			color
		);
		if (result.success) {
			setSuccess(true);
			setNewRole({ [projectToEdit]: result.roleId });

			let index = projectsList.findIndex(
				(project) => project.key === projectToEdit
			);
			if (index !== -1) {
				let updatedProjectsList = JSON.parse(
					JSON.stringify(projectsList)
				);
				updatedProjectsList[index] = {
					...updatedProjectsList[index],
					role: result.roleId,
				};
				setProjectsList(updatedProjectsList);
			}
		}
	};

	const handleClickOk = () => {
		handleCloseNewRoleModal();
		closeModal('editAccessibility');

		openModal('addUserMgmt');
		setUserSelected(userId);
	};

	return (
		<Modal
			open={openNewRoleModal}
			onClose={handleCloseNewRoleModal}
			aria-labelledby='save-new-role-preset'
			aria-describedby='save-new-role-preset'
		>
			<Box sx={style}>
				<div className={styles.save_new_role}>
					<div className={styles.save_new_role_header}>
						<h3 className={styles.save_new_role_header_title}>
							{success ? 'Saved!' : 'Saving new role preset'}
						</h3>
					</div>
					{success ? (
						<div className={styles.save_new_role_success}>
							<p className={styles.save_new_role_success_text}>
								You can manage role presets saved in role
								presets settings
							</p>
							<div className={styles.save_new_role_success_btn}>
								<CustomButton
									width={166}
									height={42}
									onClick={handleClickOk}
								>
									Ok
								</CustomButton>
							</div>
						</div>
					) : (
						<div className={styles.save_new_role_content}>
							<Grid
								container
								spacing={1}
								className={styles.role_form}
							>
								<Grid item xs={6}>
									<TextField
										fullWidth
										label='role name'
										value={roleName}
										onChange={handleChangeRoleName}
									/>
								</Grid>
								<Grid item xs={6}>
									<ColorSelector
										color={color}
										setColor={setColor}
									/>
								</Grid>
							</Grid>
							<div className={styles.footer_btn_group}>
								<Button
									className={styles.cancel_btn}
									onClick={handleCloseNewRoleModal}
								>
									Cancel
								</Button>
								<CustomButton
									width={166}
									height={42}
									disabled={!roleName || !color}
									onClick={handleSaveRole}
								>
									Save
								</CustomButton>
							</div>
						</div>
					)}
				</div>
			</Box>
		</Modal>
	);
};

export default connect(null, { closeModal, openModal })(SaveNewRoleModal);
